import React, {Component}  from 'react'
import {Modal}             from 'antd'
import { checkInviteCode } from '../../services/purchase';
import { getUrlParam, storeInviteCodeInCookie } from '../../utils/util'

const  AuthWrapper = (ComposedComponent) => class extends Component{
  constructor () {
    super()
    this.state = {
      loading: true
    }
  }

  componentDidMount () {
    const { match, location: { search } } = this.props
    const { inviteCode } = match.params;
    this.checkCode(inviteCode, search)
  }

  checkCode(inviteCode, search) {
    if(inviteCode && inviteCode !== "default"){

      // https://ltpressure.800best.com/smart/spread/#/channelPurchase?inviteCode=04S5XOBISS
      // 重定向为
      // https://ltpressure.800best.com/spread/#/channelPurchase?inviteCode=04S5XOBISS
      if (inviteCode === "channelPurchase") {
        inviteCode = getUrlParam("inviteCode", search)
      }

      // 将inviteCode写入cookie，24小时过期
      storeInviteCodeInCookie(inviteCode);

      checkInviteCode(inviteCode).then(({ status, sign }) => {
        this.setState({
          status,
          sign,
          loading: false,
          inviteCode
        })
      }).catch(() => {
        this.setState({loading: false})
      })
    }else{
      this.setState({status: true})
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { match, location: { search } } = this.props
    const {inviteCode} = match.params;
    const {inviteCode: prevInviteCode} = prevProps.match.params;
    if(inviteCode !== prevInviteCode){
      this.checkCode(inviteCode, search)
    }
  }

  render(){
    const {loading, status, sign, inviteCode} = this.state
    return (
      <>
        {status && <ComposedComponent {...this.props} inviteCode={inviteCode} sign={sign}/>}
        <Modal
          visible={!status && !loading}
          closable={false}
          footer={null}
          className={'purchase__modal'}
        >
          <p>此推广链接已无法访问，请联系渠道管理员</p>
          <p><a href={'//lt.800best.com'}>前往灵通打单</a></p>
        </Modal>
      </>

    )
  }
}

export default AuthWrapper
